<template>
  <refonte-filters-tabs-item
    label="Formations en cours / à venir"
    v-bind:selected="selectedTab === 'FORMATIONS_EN_COURS-A_VENIR'"
    v-bind:on_click="
      () => {
        handleClick('FORMATIONS_EN_COURS-A_VENIR');
      }
    " />
  <refonte-filters-tabs-item
    label="Formations passées"
    v-bind:selected="selectedTab === 'FORMATIONS_PASSEES'"
    v-bind:on_click="
      () => {
        handleClick('FORMATIONS_PASSEES');
      }
    " />
</template>

<script setup lang="ts">
  import RefonteFiltersTabsItem from '@/components/refonte/filters/refonte-filters-tabs-item.vue';
  import { computed } from 'vue';
  import {
    FORMATIONS_FILTERS_CONFIGURATION,
    useFormationFilterStore
  } from '@/stores/participant/formations';
  import { FormationFilterType } from '@/types/participant/formations-filters-types';
  const formationsFilterStore = useFormationFilterStore();
  const selectedTab = computed(
    () =>
      formationsFilterStore?.filters?.affichage ?? 'FORMATIONS_EN_COURS-A_VENIR'
  );
  const updateFilter = (
    name: string,
    value: number | string | undefined | Date | boolean
  ) => {
    formationsFilterStore.resetFilters();

    formationsFilterStore.setFilter(name, value);
  };

  const props = withDefaults(
    defineProps<{
      fetch: Function;
    }>(),
    {}
  );

  function handleClick(tab: FormationFilterType) {
    updateFilter(FORMATIONS_FILTERS_CONFIGURATION.affichage.name, tab);
    props.fetch();
  }
</script>

<style lang="scss" scoped></style>
